module.exports = __webpack_public_path__ + "static/media/wordmark.ac5a521f.svg";